import React from 'react';
import { Modal, Button } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import SuccessIcon from "../../../../Assests/success.png"
import "./SuccessModal.css"

const SuccessModal = ({ visible, onClose, title, description }) => {
    return (
        <Modal
            open={visible}
            onOk={onClose}
            onCancel={onClose}
            footer={null}
            closable={false}
            centered
            width={400}
            className="success-modal"
        >

            <CloseOutlined
                onClick={onClose}
                className="success-modal-close-icon"
            />


              <img
                src={SuccessIcon}
                height={50}
                width={50}
              />


            <h2 className="success-modal-title">
                {title || 'Event added successfully'}
            </h2>


            <p className="success-modal-description">
                {description || 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been'}
            </p>


            <Button
                type="primary"
                size="large"
                onClick={onClose}
                className="success-modal-button"             
            >
                OK
            </Button>
        </Modal>
    );
};

export default SuccessModal;